export const UrlCollection = {
  Home: "/",
  Slider: "/he-thong/bai-viet-trang-chu",
  PlanningAnnouncementProcess: "/qhdt/quy-trinh-cong-bo-quy-hoach",
  ProjectManagement:"/qhdt/quan-ly-du-an-dtxd",
  MapProjectManagement:"/qhdt/ban-do-quan-ly-du-an-dtxd",
  LandUsePLanningManagement:"/qhdt/quan-ly-quy-hoach-ke-hoach-sdd",
  TrafficPlanningManagement:"/qhdt/quan-ly-quy-hoach-giao-thong",
  EmailTemplate: "/he-thong/email-template",
  RoleManagement: "/he-thong/role-management",
  ContactManagement: "/he-thong/contact-management",
  EmailGenerated: "/he-thong/email-generated",
  UserManagement: "/he-thong/quan-ly-nguoi-dung",
  StreetManagement: "/he-thong/quan-ly-duong",
  CommuneManagement: "/he-thong/quan-ly-xa-phuong",
  DistrictManagement: "/he-thong/quan-ly-quan-huyen",
  ProvinceManagement: "/he-thong/quan-ly-thanh-pho",
  LinkGroup: "/he-thong/danh-sach-nhom",
  ServiceLink: "/he-thong/danh-sach-lien-ket",
  UserLogHistory: "/he-thong/nhat-ky-nguoi-dung",
  LandType: "/he-thong/quan-ly-loai-dat",
  LandTypeDetail: "/he-thong/quan-ly-chi-tiet-loai-dat",
  News: "/tin-tuc",

    CategoryParent: "/category-parent",
    DocumentManagement: "/document-management",
  //--- Account
  Login: "/dang-nhap",
  LoginFromMobile: "/login-from-mobile",
  Register: "/dang-ky",
  ForgotPassword: "/quen-mat-khau",
  ConfirmCode: "/xac-nhan",
  ResetPassword: "/dat-lai-mat-khau",
  MapData: '/qhdt/ban-do',
  CreateMapData: '/thiet-dat-thong-so-ban-do/:mapKey',
  AccessDenied: '/403',
  OpinionForm: '/he-thong/tao-form-y-kien',

  //--- Table structure
  TableStructure: '/he-thong/sua-cau-truc-bang',
  Place: "/he-thong/quan-ly-dia-diem",
  PlaceType: "/he-thong/quan-ly-loai-dia-diem",
  PlaceKind: "/he-thong/quan-ly-chi-tiet-loai-dia-diem",

  //---remote sensing

  MapRemoteSensing: "/ban-do-vien-tham",
  HistoryRemoteSensing: "/lich-su-bien-dong",
  PhotoGalleryRemoteSensing: "/kho-anh-hien-trang",
  InfomationTableRemoteSensing: "/ban-bieu-thong-tin",
  RemoteSensingManagement: "/quan-ly-bien-dong",
  RemoteSensingPending: "/danh-sach-cho",
  RemoteSensingList: "/danh-sach-bien-dong",
};
